// extracted by mini-css-extract-plugin
module.exports = {"root":"ClassTypeCheckboxes_root__1AMzD"};